import {
    Pipe,
    PipeTransform
} from '@angular/core';
import {
    DomSanitizer
} from '@angular/platform-browser';

@Pipe({
    name: 'sanitizeHtml',
})
export class SanitizeHtmlPipe implements PipeTransform {

    constructor(private _sanitizer: DomSanitizer) {};

    transform(value: string, ...args) {
        if (value) {
            return this._sanitizer.bypassSecurityTrustResourceUrl(value);
        } else {
            return value;
        }
    }
}


// WEBPACK FOOTER //
// ./src/pipes/sanitize-html/sanitize-html.ts